import Select from "react-select";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { onDishChangeTaxes } from "../../store/Dish/actions";

const Tax = ({ tax, dishTax, isAllDisabled, formik }) => {
    const { t } = useTranslation();
    const handleChange = ({ value }) => {
        formik.setFieldValue("tax_percent", value);
    };

    const enabledTaxes = tax.filter(({is_enable}) => is_enable)
    const taxOptions = enabledTaxes.map((item) => ({ value: item.rate, label: item.rate }));

    const defaultOption = { label: dishTax, value: dishTax }

    const customSelectStyles = {
        control: base => ({
            ...base,
            height: 40,
            background: 'rgb(243, 244, 246)',
        }),
        dropdownIndicator: (base) => ({ ...base, color: "#504DE2" }),
        menuList: (base) => ({ ...base }),
        input: (base) => ({ ...base, border: '1px',padding: "1px"}),
    };

    return (
        <>
            <Select
                name="tax"
                isDisabled={isAllDisabled}
                options={taxOptions}
                className="w-full"
                onChange={handleChange}
                value={defaultOption}
                placeholder={t("Select")}
                styles={customSelectStyles}
                isSearchable={false}
            />
        </>
    );
};

export default Tax;
